import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {
  updateSingleCod,
  importCod,
  codUpdateTemplate,
  exportConsignments,
  exportPostConsignments,
  exportPackageWaybill,
  updateBulkCod,
  getCustomerSequencer,
  exportCustomerSequencer,
  postCustomerSequencer,
  activateCustomerSequencer,
  getSequencerStatus,
  exportConsignmentEvents,
  exportPackageEvents,
  exportAllPackageEvents,
  desAddressUpdateTemplate,
  importDesAddress,
  importOriginAddress,
  downloadConsignmentProof,
  downloadDeliveryProof,
  downloadPaymentProof,
  downloadSignatureProof,
  downloadSignaturesProof,
  downloadPackagesProof,
  getPackage,
  postReconcileOrder,
  notifyBadAddress,
  updateBadAddress,
  exportPackage,
  getBadAddressbyFilter,
  getPaymentType,
  getEstimatedDate,
  getBadAddressWaybillList,
  deleteBadAddress,
  getBadAddressCategory,
  getShipmentType,
  getBadAddressSubcategory,
  getBadAddressWaybill,
  changeDesAddress,
  changeDestinationAddress,
  getAddressChangeHistory,
  exportBadAddressWaybillList,
  resolveByShortAddress,
  resolveByShortAddressV2,
  resolveByGeoCode,
  consignmentAddressHistory,
  consignmentLocationHistory,
  consignmentAddressHis,
  deleteCacheEntry,
  postOrderConsignmentsReconcile,
  validateShortAddress,
} from "../../services/OrderManagement/Order_services";
const initialValues = {
  customerSeqStatus: [],
  addressCategory: [],
  addressSubCategory: [],
  shipmentTypesList: [],
   payrollTypeList: [],
};
let orderStore = (set) => ({
  ...initialValues,
  updateSingleCod: async (params, data) => {
    const response = await updateSingleCod(params, data);
    return response;
  },
  importCod: async (params) => {
    const response = await importCod(params);
    return response;
  },
  codUpdateTemplate: async (params) => {
    const response = await codUpdateTemplate(params);
    return response;
  },
  importDesAddress: async (params) => {
    const response = await importDesAddress(params);
    return response;
  },
    importOriginAddress: async (params) => {
    const response = await importOriginAddress(params);
    return response;
  },
  desAddressUpdateTemplate: async (params) => {
    const response = await desAddressUpdateTemplate(params);
    return response;
  },
  exportConsignments: async (params) => {
    const response = await exportConsignments(params);
    return response;
  },
  exportPostConsignments: async (params) => {
    const response = await exportPostConsignments(params);
    return response;
  },
  exportPackageWaybill: async (params) => {
    const response = await exportPackageWaybill(params);
    return response;
  },
  getCustomerSequencer: async (params) => {
    const response = await getCustomerSequencer(params);
    return response;
  },
  exportCustomerSequencer: async (params) => {
    const response = await exportCustomerSequencer(params);
    return response;
  },
  updateBulkCod: async (params) => {
    const response = await updateBulkCod(params);
    return response;
  },
  postCustomerSequencer: async (data) => {
    const response = await postCustomerSequencer(data);
    return response;
  },
  activateCustomerSequencer: async (params, data) => {
    const response = await activateCustomerSequencer(params, data);
    return response;
  },
  exportConsignmentEvents: async (params) => {
    const response = await exportConsignmentEvents(params);
    return response;
  },
  exportPackageEvents: async (params) => {
    const response = await exportPackageEvents(params);
    return response;
  },
  exportAllPackageEvents: async (params) => {
    const response = await exportAllPackageEvents(params);
    return response;
  },
  downloadConsignmentProof: async (params) => {
    const response = await downloadConsignmentProof(params);
    return response;
  },
  downloadSignaturesProof: async (params) => {
    const response = await downloadSignaturesProof(params);
    return response;
  },
  downloadDeliveryProof: async (params) => {
    const response = await downloadDeliveryProof(params);
    return response;
  },
  downloadPaymentProof: async (params) => {
    const response = await downloadPaymentProof(params);
    return response;
  },
  downloadSignatureProof: async (params) => {
    const response = await downloadSignatureProof(params);
    return response;
  },
  downloadPackagesProof: async (params) => {
    const response = await downloadPackagesProof(params);
    return response;
  },
  getSequencerStatus: async () => {
    const response = await getSequencerStatus();
    set({ customerSeqStatus: response });
    return response;
  },
  getPackage: async (params) => {
    const response = await getPackage(params);
    return response;
  },
    postReconcileOrder: async (params) => {
    const response = await postReconcileOrder(params);
    return response;
  },
      notifyBadAddress: async (params) => {
    const response = await notifyBadAddress(params);
    return response;
  },
     updateBadAddress: async (params, data) => {
    const response = await updateBadAddress(params, data);
    return response;
  },
  exportPackage: async (params) => {
    const response = await exportPackage(params);
    return response;
  },
  getBadAddressbyFilter: async (params) => {
    const response = await getBadAddressbyFilter(params);
    return response;
  },
  getBadAddressWaybillList: async (params) => {
    const response = await getBadAddressWaybillList(params);
    return response;
  },
  deleteBadAddress: async (params) => {
    const response = await deleteBadAddress(params);
    return response;
  },
    getBadAddressWaybill: async (params) => {
    const response = await getBadAddressWaybill(params);
    return response;
  },
changeDesAddress: async (params,data) => {
    const response = await changeDesAddress(params,data);
    return response;
  },
    changeDestinationAddress: async (params,data) => {
    const response = await changeDestinationAddress(params,data);
    return response;
  },
    getAddressChangeHistory: async (params) => {
    const response = await getAddressChangeHistory(params);
    return response;
  },
    exportBadAddressWaybillList: async (params) => {
    const response = await exportBadAddressWaybillList(params);
    return response;
  },
    resolveByShortAddress: async (params) => {
    const response = await resolveByShortAddress(params);
    return response;
  },
      resolveByShortAddressV2: async (params) => {
    const response = await resolveByShortAddressV2(params);
    return response;
  },
    resolveByGeoCode: async (params,params2) => {
    const response = await resolveByGeoCode(params,params2);
    return response;
  },
   getBadAddressCategory: async () => {
    const response = await getBadAddressCategory();
      set({ addressCategory: response });
    return response;
  },
   getBadAddressSubcategory: async () => {
    const response = await getBadAddressSubcategory();
      set({ addressSubCategory: response });
    return response;
  },
   getShipmentType: async () => {
        const response = await getShipmentType();
        set({ shipmentTypesList: response });
        return response;
      },
    consignmentAddressHistory: async (params) => {
    const response = await consignmentAddressHistory(params);
    return response;
  },
      consignmentLocationHistory: async (params) => {
    const response = await consignmentLocationHistory(params);
    return response;
  },
    consignmentAddressHis: async (params) => {
    const response = await consignmentAddressHis(params);
    return response;
  },
   getPaymentType: async () => {
          const response = await getPaymentType();
          set({ paymentListType: response });
          return response;
        },
          getEstimatedDate: async (params) => {
    const response = await getEstimatedDate(params);
    return response;
  },
  deleteCacheEntry: async (trackingId) => {
    const response = await deleteCacheEntry(trackingId);
    return response;
  },
  postOrderConsignmentsReconcile: async (data) => {
    const response = await postOrderConsignmentsReconcile(data);
    return response;
  },
  validateShortAddress: async (data) => {
    const response = await validateShortAddress(data);
    return response;
  },
});

orderStore = devtools(orderStore);

export const useOrderStore = create(orderStore);
